export const UnitActiveIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.41667 8.33333C3.80583 8.33333 2.5 7.0275 2.5 5.41667C2.5 3.80583 3.80583 2.5 5.41667 2.5C7.0275 2.5 8.33333 3.80583 8.33333 5.41667C8.33333 7.0275 7.0275 8.33333 5.41667 8.33333Z"
        fill="#021316"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5837 8.33333C12.9728 8.33333 11.667 7.0275 11.667 5.41667C11.667 3.80583 12.9728 2.5 14.5837 2.5C16.1945 2.5 17.5003 3.80583 17.5003 5.41667C17.5003 7.0275 16.1945 8.33333 14.5837 8.33333Z"
        fill="#021316"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.41667 17.4993C3.80583 17.4993 2.5 16.1935 2.5 14.5827C2.5 12.9718 3.80583 11.666 5.41667 11.666C7.0275 11.666 8.33333 12.9718 8.33333 14.5827C8.33333 16.1935 7.0275 17.4993 5.41667 17.4993Z"
        fill="#F2DB46"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5003 14.5827C17.5003 12.9718 16.1945 11.666 14.5837 11.666C12.9728 11.666 11.667 12.9718 11.667 14.5827C11.667 16.1935 12.9728 17.4993 14.5837 17.4993C16.1945 17.4993 17.5003 16.1935 17.5003 14.5827Z"
        fill="#021316"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UnitIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.41667 8.33333V8.33333C3.80583 8.33333 2.5 7.0275 2.5 5.41667V5.41667C2.5 3.80583 3.80583 2.5 5.41667 2.5V2.5C7.0275 2.5 8.33333 3.80583 8.33333 5.41667V5.41667C8.33333 7.0275 7.0275 8.33333 5.41667 8.33333Z"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5832 8.33333V8.33333C12.9723 8.33333 11.6665 7.0275 11.6665 5.41667V5.41667C11.6665 3.80583 12.9723 2.5 14.5832 2.5V2.5C16.194 2.5 17.4998 3.80583 17.4998 5.41667V5.41667C17.4998 7.0275 16.194 8.33333 14.5832 8.33333Z"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.41667 17.4993V17.4993C3.80583 17.4993 2.5 16.1935 2.5 14.5827V14.5827C2.5 12.9718 3.80583 11.666 5.41667 11.666V11.666C7.0275 11.666 8.33333 12.9718 8.33333 14.5827V14.5827C8.33333 16.1935 7.0275 17.4993 5.41667 17.4993Z"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4998 14.5827V14.5827C17.4998 12.9718 16.194 11.666 14.5832 11.666V11.666C12.9723 11.666 11.6665 12.9718 11.6665 14.5827V14.5827C11.6665 16.1935 12.9723 17.4993 14.5832 17.4993V17.4993C16.194 17.4993 17.4998 16.1935 17.4998 14.5827Z"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const PlusIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#021316" />
      <path
        d="M10 6V14"
        stroke="#F2DB46"
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 10H6"
        stroke="#F2DB46"
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DeactivateIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33252 8.66699L7.33335 10.6678"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.33335 8.66699L5.33252 10.6678"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.3327 14.0023C3.93847 14.0023 1.99756 12.0614 1.99756 9.66717C1.99756 7.27294 3.93847 5.33203 6.3327 5.33203C8.72693 5.33203 10.6678 7.27294 10.6678 9.66717C10.6678 12.0614 8.72693 14.0023 6.3327 14.0023"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.586 10.0014C13.9502 8.67977 14.3752 6.66222 13.6602 4.90255C12.9452 3.14288 11.2334 1.99362 9.33398 1.99806"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33423 1.99805C8.11697 1.9986 6.94872 2.47769 6.08154 3.33194"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ActivateIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7L7.5 9.5L6 8"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0002 6.66667C13.4692 4.34438 11.6558 2.53098 9.3335 2"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66667 13.9997C4.34439 13.4687 2.53099 11.6553 2 9.33301"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66667 2C4.34438 2.53098 2.53098 4.34438 2 6.66667"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0002 9.33301C13.4692 11.6553 11.6558 13.4687 9.3335 13.9997"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const UserIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8478 3.47241C14.1443 4.76895 14.1443 6.87106 12.8478 8.1676C11.5512 9.46414 9.44912 9.46414 8.15258 8.1676C6.85604 6.87106 6.85604 4.76895 8.15258 3.47241C9.44912 2.17586 11.5512 2.17586 12.8478 3.47241"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 11.6738C14.295 11.6738 18 13.313 18 15.8338V16.6672C18 17.1272 17.6267 17.5005 17.1667 17.5005H3.83333C3.37333 17.5005 3 17.1272 3 16.6672V15.8338C3 13.3122 6.705 11.6738 10.5 11.6738"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M12.5 15L14.5 15" stroke="#021316" stroke-linecap="round" />
    </svg>
  );
};
export const UserActiveIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8473 3.47241C14.1438 4.76895 14.1438 6.87106 12.8473 8.1676C11.5507 9.46414 9.44864 9.46414 8.15209 8.1676C6.85555 6.87106 6.85555 4.76895 8.15209 3.47241C9.44864 2.17586 11.5507 2.17586 12.8473 3.47241Z"
        fill="#021316"
      />
      <path
        d="M12.8473 3.47241C14.1438 4.76895 14.1438 6.87106 12.8473 8.1676C11.5507 9.46414 9.44864 9.46414 8.15209 8.1676C6.85555 6.87106 6.85555 4.76895 8.15209 3.47241C9.44864 2.17586 11.5507 2.17586 12.8473 3.47241"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 11.6738C14.295 11.6738 18 13.313 18 15.8338V16.6672C18 17.1272 17.6267 17.5005 17.1667 17.5005H3.83333C3.37333 17.5005 3 17.1272 3 16.6672V15.8338C3 13.3122 6.705 11.6738 10.5 11.6738Z"
        fill="#021316"
      />
      <path
        d="M10.5 11.6738C14.295 11.6738 18 13.313 18 15.8338V16.6672C18 17.1272 17.6267 17.5005 17.1667 17.5005H3.83333C3.37333 17.5005 3 17.1272 3 16.6672V15.8338C3 13.3122 6.705 11.6738 10.5 11.6738"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M12.5 15L14.5 15" stroke="#D9C334" stroke-linecap="round" />
    </svg>
  );
};
export const UnitGridIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.25 5.5V5.5C2.2835 5.5 1.5 4.7165 1.5 3.75V3.75C1.5 2.7835 2.2835 2 3.25 2V2C4.2165 2 5 2.7835 5 3.75V3.75C5 4.7165 4.2165 5.5 3.25 5.5Z"
        stroke="#787771"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.75 5.5V5.5C7.7835 5.5 7 4.7165 7 3.75V3.75C7 2.7835 7.7835 2 8.75 2V2C9.7165 2 10.5 2.7835 10.5 3.75V3.75C10.5 4.7165 9.7165 5.5 8.75 5.5Z"
        stroke="#787771"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.25 11.001V11.001C2.2835 11.001 1.5 10.2175 1.5 9.25098V9.25098C1.5 8.28448 2.2835 7.50098 3.25 7.50098V7.50098C4.2165 7.50098 5 8.28448 5 9.25098V9.25098C5 10.2175 4.2165 11.001 3.25 11.001Z"
        stroke="#787771"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 9.25098V9.25098C10.5 8.28448 9.7165 7.50098 8.75 7.50098V7.50098C7.7835 7.50098 7 8.28448 7 9.25098V9.25098C7 10.2175 7.7835 11.001 8.75 11.001V11.001C9.7165 11.001 10.5 10.2175 10.5 9.25098Z"
        stroke="#787771"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const HeaderIcon = () => {
  return (
    <svg
      width="142"
      height="32"
      viewBox="0 0 142 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.8735 8.3656C59.8735 9.15128 59.1885 9.77579 58.4028 9.77579H54.8449V15.8396H52.085V3.61125C52.085 2.82557 52.7095 2.14062 53.4951 2.14062H61.6664V4.5178H54.8449V7.45905H59.8735V8.3656Z"
        fill="#113541"
      />
      <path
        d="M62.7975 2.14062H64.1876C65.074 2.14062 65.497 2.58383 65.4769 3.45009V4.23576H62.7975V2.14062ZM62.7975 5.1826H64.1876C65.0538 5.1826 65.4769 5.60566 65.4769 6.47192V15.8396H62.7975V5.1826Z"
        fill="#113541"
      />
      <path
        d="M75.993 12.576C75.4088 14.8323 73.9583 16.0813 71.3394 16.0813C68.1161 15.9806 66.5045 14.1071 66.5045 10.4809C66.5045 6.85468 68.1362 5.04158 71.3797 5.02144C74.7641 5.02144 76.3556 7.09643 76.1542 11.2666H69.2644C69.3651 12.8984 70.0702 13.7243 71.3797 13.7243C72.0042 13.7243 72.5884 13.4624 73.1122 12.9588C73.3539 12.6969 73.6561 12.576 74.0187 12.576H75.993ZM71.3394 7.2173C70.1911 7.2173 69.5061 7.94254 69.3047 9.35273H73.3137C73.1525 7.94254 72.4877 7.2173 71.3394 7.2173Z"
        fill="#113541"
      />
      <path
        d="M78.3925 2.14062C79.0976 2.14062 79.6819 2.74499 79.6819 3.45009V15.8396H77.0025V2.14062H78.3925Z"
        fill="#113541"
      />
      <path
        d="M85.7055 7.41876C84.2551 7.41876 83.5097 8.42604 83.4291 10.4809C83.4089 12.6365 84.1342 13.7243 85.6652 13.7243C87.1963 13.7243 87.9618 12.6365 87.9618 10.4809C87.9014 8.42604 87.156 7.41876 85.7055 7.41876ZM89.2914 2.14062C90.0167 2.14062 90.621 2.76514 90.621 3.49038V11.2263C90.621 14.4294 88.949 16.0209 85.6249 16.0008C82.3211 15.9403 80.6691 14.1474 80.6691 10.6018C80.6691 6.97556 82.0793 5.12217 84.9199 5.02144C86.2495 5.02144 87.2769 5.56537 87.9618 6.67337V2.14062H89.2914Z"
        fill="#113541"
      />
      <path
        d="M103.135 8.3656C103.135 9.15128 102.45 9.77579 101.664 9.77579H98.1062V15.8396H95.3462V3.61125C95.3462 2.82557 95.9707 2.14062 96.7564 2.14062H104.928V4.5178H98.1062V7.45905H103.135V8.3656Z"
        fill="#113541"
      />
      <path
        d="M109.436 5.02144C112.659 5.02144 114.291 6.85468 114.291 10.5615C114.291 14.228 112.659 16.0813 109.436 16.0813C106.213 16.0813 104.601 14.228 104.601 10.5615C104.601 6.85468 106.213 5.02144 109.436 5.02144ZM109.436 7.37847C108.026 7.37847 107.321 8.44618 107.321 10.5615C107.341 12.6365 108.046 13.684 109.416 13.684C110.786 13.684 111.471 12.5962 111.491 10.4809C111.491 8.40589 110.806 7.37847 109.436 7.37847Z"
        fill="#113541"
      />
      <path
        d="M115.178 15.8396V10.3399C115.258 6.89497 117.092 5.1826 120.657 5.1826H121.04V7.96269H120.134C118.643 7.96269 117.897 8.74837 117.897 10.2996V15.8396H115.178Z"
        fill="#113541"
      />
      <path
        d="M131.285 12.576C130.801 14.7517 129.23 16.1418 126.752 16.0813C123.529 16.0813 121.877 14.228 121.796 10.5615C121.796 6.91512 123.428 5.08188 126.712 5.02144C129.291 5.02144 130.822 6.16974 131.285 8.48647H128.364C128.042 7.76123 127.477 7.37847 126.631 7.37847C125.221 7.37847 124.516 8.44618 124.516 10.5615C124.516 12.6767 125.261 13.7445 126.752 13.7243C127.377 13.7243 127.921 13.4624 128.364 12.9588C128.626 12.6969 128.928 12.576 129.27 12.576H131.285Z"
        fill="#113541"
      />
      <path
        d="M141.702 12.576C141.118 14.8323 139.668 16.0813 137.049 16.0813C133.825 15.9806 132.214 14.1071 132.214 10.4809C132.214 6.85468 133.846 5.04158 137.089 5.02144C140.474 5.02144 142.065 7.09643 141.864 11.2666H134.974C135.075 12.8984 135.78 13.7243 137.089 13.7243C137.714 13.7243 138.298 13.4624 138.822 12.9588C139.063 12.6969 139.365 12.576 139.728 12.576H141.702ZM137.049 7.2173C135.9 7.2173 135.216 7.94254 135.014 9.35273H139.023C138.862 7.94254 138.197 7.2173 137.049 7.2173Z"
        fill="#113541"
      />
      <path
        d="M52.085 18.584C52.085 17.9444 52.5934 17.3867 53.2331 17.3867H55.4473L57.6943 25.8828L59.8758 17.3867H63.2709V28.5399H61.1223V19.5353L58.8425 28.5399H56.5134L54.2336 19.5353V28.5399H52.085V18.584Z"
        fill="#113541"
      />
      <path
        d="M67.453 26.768C68.6667 26.768 69.4048 26.0464 69.4048 24.8162V24.0125C68.8963 24.2258 68.3059 24.4062 67.6662 24.5374C66.7969 24.7014 66.3541 25.1115 66.3541 25.7511C66.4033 26.44 66.7641 26.768 67.453 26.768ZM67.9614 21.3555C67.1906 21.3555 66.7641 21.5523 66.6493 21.9623H64.4679C64.7303 20.355 65.862 19.5677 67.863 19.5677C70.2577 19.5677 71.4714 20.355 71.5206 21.9623V24.9146C71.5206 27.3093 70.0773 28.3754 67.7318 28.5394C65.6488 28.7034 64.2054 27.7357 64.2054 25.8167C64.2547 23.7337 65.7636 23.1761 67.9614 22.9628C68.8963 22.848 69.372 22.5692 69.372 22.0935C69.3228 21.6015 68.8635 21.3555 67.9614 21.3555Z"
        fill="#113541"
      />
      <path
        d="M79.9683 28.5399H78.8529C78.1313 28.4907 77.7704 28.1462 77.7704 27.4574V22.9961C77.7212 22.094 77.2292 21.6512 76.2615 21.6512C75.2938 21.6512 74.8017 22.094 74.7853 22.9961V28.5399H72.5711V23.439C72.5711 20.9623 73.8176 19.7322 76.2943 19.7322C78.7709 19.7322 79.9847 20.9623 79.9683 23.439V28.5399Z"
        fill="#113541"
      />
      <path
        d="M83.9989 26.768C85.2126 26.768 85.9507 26.0464 85.9507 24.8162V24.0125C85.4422 24.2258 84.8518 24.4062 84.2121 24.5374C83.3428 24.7014 82.8999 25.1115 82.8999 25.7511C82.9492 26.44 83.31 26.768 83.9989 26.768ZM84.5073 21.3555C83.7364 21.3555 83.31 21.5523 83.1952 21.9623H81.0137C81.2762 20.355 82.4079 19.5677 84.4089 19.5677C86.8036 19.5677 88.0173 20.355 88.0665 21.9623V24.9146C88.0665 27.3093 86.6231 28.3754 84.2777 28.5394C82.1947 28.7034 80.7513 27.7357 80.7513 25.8167C80.8005 23.7337 82.3095 23.1761 84.5073 22.9628C85.4422 22.848 85.9179 22.5692 85.9179 22.0935C85.8687 21.6015 85.4094 21.3555 84.5073 21.3555Z"
        fill="#113541"
      />
      <path
        d="M93.0534 26.6204C94.2343 26.6204 94.8576 25.7839 94.9232 24.1109C94.9396 22.356 94.3327 21.4867 93.0862 21.4867C91.8397 21.4867 91.2328 22.356 91.2328 24.1109C91.282 25.7839 91.8725 26.6204 93.0534 26.6204ZM92.4465 28.5394C90.1339 28.5394 88.9858 27.0305 88.9858 24.0453C88.9858 21.1586 90.3307 19.7153 93.0206 19.6661C95.7269 19.6497 97.0882 20.929 97.0882 23.5369V28.6706C97.0882 30.8521 95.7105 31.951 92.9386 32.0002C90.9704 32.0002 89.7238 31.0817 89.2154 29.2447H91.6264C91.774 29.868 92.2825 30.1632 93.1846 30.1632C94.3327 30.1632 94.9232 29.4907 94.9232 28.1458C94.9232 28.1458 94.9232 28.1622 94.9232 27.2601C94.3655 28.113 93.529 28.5394 92.4465 28.5394Z"
        fill="#113541"
      />
      <path
        d="M105.762 25.7183C105.287 27.5553 104.106 28.5722 101.973 28.5722C99.3492 28.4902 98.0371 26.9648 98.0371 24.0125C98.0371 21.0602 99.3656 19.5841 102.006 19.5677C104.762 19.5677 106.058 21.2571 105.893 24.6522H100.284C100.366 25.9807 100.94 26.6532 102.006 26.6532C102.515 26.6532 102.99 26.44 103.417 26.03C103.614 25.8167 103.86 25.7183 104.155 25.7183H105.762ZM101.973 21.3555C101.039 21.3555 100.481 21.9459 100.317 23.094H103.581C103.45 21.9459 102.908 21.3555 101.973 21.3555Z"
        fill="#113541"
      />
      <path
        d="M110.603 21.6184C109.635 21.6184 109.143 22.0612 109.126 22.9633V28.5071H106.912V23.4062C106.912 20.9295 108.159 19.6994 110.635 19.6994C111.751 19.6994 112.604 19.9454 113.227 20.4374C113.85 19.9618 114.703 19.7322 115.818 19.7322C118.295 19.7322 119.525 20.9623 119.509 23.439V28.5399H118.377C117.655 28.4907 117.294 28.1462 117.294 27.4574V22.9961C117.245 22.094 116.753 21.6512 115.786 21.6512C114.818 21.6512 114.326 22.094 114.309 22.9961V28.5071H112.112V22.9633C112.062 22.0612 111.57 21.6184 110.603 21.6184Z"
        fill="#113541"
      />
      <path
        d="M128.427 25.7183C127.951 27.5553 126.77 28.5722 124.638 28.5722C122.014 28.4902 120.702 26.9648 120.702 24.0125C120.702 21.0602 122.03 19.5841 124.671 19.5677C127.426 19.5677 128.722 21.2571 128.558 24.6522H122.949C123.031 25.9807 123.605 26.6532 124.671 26.6532C125.179 26.6532 125.655 26.44 126.081 26.03C126.278 25.8167 126.524 25.7183 126.819 25.7183H128.427ZM124.638 21.3555C123.703 21.3555 123.145 21.9459 122.981 23.094H126.245C126.114 21.9459 125.573 21.3555 124.638 21.3555Z"
        fill="#113541"
      />
      <path
        d="M136.974 28.5399H135.859C135.137 28.4907 134.776 28.1462 134.776 27.4574V22.9961C134.727 22.094 134.235 21.6512 133.267 21.6512C132.299 21.6512 131.807 22.094 131.791 22.9961V28.5399H129.577V23.439C129.577 20.9623 130.823 19.7322 133.3 19.7322C135.777 19.7322 136.99 20.9623 136.974 23.439V28.5399Z"
        fill="#113541"
      />
      <path
        d="M141.447 20.3806C141.447 21.0039 140.972 21.4631 140.365 21.4631H140.135V26.2688C140.135 26.6297 140.348 26.8265 140.775 26.8265H141.447V28.4831C140.742 28.5487 139.971 28.5487 139.151 28.4667C138.331 28.3847 137.937 27.8762 137.954 26.9085V17.4283H139.085C139.66 17.4283 140.135 17.9532 140.135 18.5272V19.905H141.447V20.3806Z"
        fill="#113541"
      />
      <g clip-path="url(#clip0_1880_4371)">
        <path
          d="M28.2507 0.0927734V0.0999084L27.787 0.909723C27.7834 0.916858 27.7798 0.920425 27.7798 0.923993L25.0365 5.7472L19.5889 15.3294C19.5426 15.4079 19.4962 15.4899 19.4498 15.5684L13.2817 26.4171C11.8226 28.9821 9.09703 30.5661 6.14317 30.5661H0L13.3709 7.05646L14.9691 4.2453C15.0119 4.17395 15.0547 4.09547 15.0975 4.02412C15.1011 4.01698 15.1046 4.01342 15.1082 4.00628L15.1153 3.99558C15.1367 3.9599 15.1617 3.92066 15.1867 3.88499C15.3829 3.59246 15.597 3.31419 15.8288 3.05377C17.2772 1.42344 19.2251 0.513734 21.3477 0.203365C21.4904 0.18196 21.6331 0.164123 21.7758 0.149853C22.0184 0.124881 22.261 0.103476 22.5036 0.0927734H28.2507Z"
          fill="url(#paint0_linear_1880_4371)"
        />
        <path
          d="M32.0187 22.5288C32.6323 21.3836 33.8203 20.6594 35.1188 20.638L39.7851 20.5667L37.7195 24.4231C37.1059 25.5682 35.9215 26.2924 34.6229 26.3103L29.9531 26.3816L32.0187 22.5288Z"
          fill="#347287"
        />
        <path
          d="M35.1539 12.1189L33.3095 15.3652L27.0201 26.4244C25.5574 28.993 22.8319 30.5769 19.8816 30.5769H13.7349L21.4513 17.0134C21.4513 17.0134 21.4691 16.9813 21.4763 16.9635L23.2671 13.817C23.3313 13.7028 23.3991 13.5887 23.4705 13.4781C23.6025 13.2711 23.7452 13.0714 23.8914 12.8823C23.9485 12.8109 24.0056 12.7396 24.0627 12.6682C25.6573 10.7561 28.0868 9.67871 30.6125 9.67871H30.6339C31.7327 9.68228 32.8279 9.67871 33.9267 9.67871C35.0683 9.81071 35.7425 11.0843 35.1539 12.1189Z"
          fill="url(#paint1_linear_1880_4371)"
        />
        <path
          d="M43.523 9.63232C42.9022 9.63232 42.1669 12.4934 41.9529 12.9893C41.4178 14.2379 40.6508 15.4509 39.4307 16.1251C37.6577 17.1062 35.4209 16.6424 33.762 15.6506C33.6086 15.5579 33.4588 15.4651 33.3089 15.3652C32.3564 14.7445 31.4681 14.0274 30.4764 13.4781C26.834 11.4731 23.5341 14.0738 21.4507 17.0134C21.4578 16.9956 21.4685 16.9813 21.4757 16.9635L23.2665 13.817C23.3307 13.7028 23.3985 13.5886 23.4699 13.4781C23.6019 13.2711 23.7446 13.0714 23.8908 12.8823C23.9479 12.8109 24.005 12.7396 24.0621 12.6682C25.6567 10.7561 28.0862 9.6787 30.6119 9.6787H30.6333C31.7321 9.68227 32.8273 9.6787 33.9261 9.6787L43.523 9.63232Z"
          fill="#347287"
        />
        <path
          d="M37.1017 0.000293296C36.6522 0.000293296 35.9282 2.61525 35.7712 2.97199C34.7687 5.30511 33.0778 6.96399 30.42 7.16733C28.5399 7.31003 26.6813 6.69999 25.0367 5.74748C24.7442 5.58338 24.4623 5.405 24.1876 5.2195C22.9069 4.35617 21.6583 3.27166 20.1243 3.10756C17.5201 2.82573 14.8944 5.0768 13.3711 7.05674L14.9693 4.24558C15.0121 4.17423 15.0549 4.09574 15.0977 4.02439C15.1013 4.01726 15.1049 4.01369 15.1084 4.00656L15.1156 3.99585C15.137 3.96018 15.162 3.92094 15.1869 3.88526C15.3831 3.59273 15.5972 3.31447 15.8291 3.05404C17.2775 1.42371 19.2253 0.51401 21.3479 0.203641C21.4906 0.182236 21.6333 0.164399 21.776 0.150129C22.0186 0.125157 22.2612 0.103752 22.5038 0.0930495C27.352 -0.120998 32.2464 0.000293296 37.1017 0.000293296Z"
          fill="#347287"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1880_4371"
          x1="12.7125"
          y1="6.59637"
          x2="12.6907"
          y2="23.9925"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#194959" />
          <stop offset="1" stop-color="#347287" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1880_4371"
          x1="23.4709"
          y1="14.1388"
          x2="23.4575"
          y2="26.0688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#194959" />
          <stop offset="1" stop-color="#347287" />
        </linearGradient>
        <clipPath id="clip0_1880_4371">
          <rect width="43.5231" height="30.6802" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Header = () => {
  return (
    <svg
      width="150"
      height="34"
      viewBox="0 0 150 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63.2989 8.84494C63.2989 9.67558 62.5748 10.3358 61.7442 10.3358H57.9826V16.7467H55.0647V3.81847C55.0647 2.98782 55.7249 2.26367 56.5556 2.26367H65.1945V4.77691H57.9826V7.8865H63.2989V8.84494Z"
        fill="#113541"
      />
      <path
        d="M66.3903 2.26367H67.8599C68.7971 2.26367 69.2443 2.73224 69.223 3.64808V4.47873H66.3903V2.26367ZM66.3903 5.47976H67.8599C68.7758 5.47976 69.223 5.92703 69.223 6.84287V16.7467H66.3903V5.47976Z"
        fill="#113541"
      />
      <path
        d="M80.341 13.2963C79.7233 15.6818 78.1898 17.0023 75.421 17.0023C72.0133 16.8958 70.3094 14.915 70.3094 11.0813C70.3094 7.24754 72.0346 5.33067 75.4636 5.30937C79.0418 5.30937 80.7244 7.50313 80.5114 11.9119H73.2273C73.3338 13.6371 74.0792 14.5104 75.4636 14.5104C76.1239 14.5104 76.7416 14.2335 77.2953 13.701C77.5509 13.4241 77.8704 13.2963 78.2537 13.2963H80.341ZM75.421 7.63092C74.207 7.63092 73.4829 8.39767 73.2699 9.88857H77.5083C77.3379 8.39767 76.6351 7.63092 75.421 7.63092Z"
        fill="#113541"
      />
      <path
        d="M82.8778 2.26367C83.6233 2.26367 84.2409 2.90263 84.2409 3.64808V16.7467H81.4082V2.26367H82.8778Z"
        fill="#113541"
      />
      <path
        d="M90.6094 7.8439C89.0759 7.8439 88.2878 8.90883 88.2026 11.0813C88.1813 13.3602 88.9481 14.5104 90.5668 14.5104C92.1854 14.5104 92.9948 13.3602 92.9948 11.0813C92.9309 8.90883 92.1428 7.8439 90.6094 7.8439ZM94.4005 2.26367C95.1672 2.26367 95.8062 2.92393 95.8062 3.69068V11.8693C95.8062 15.2558 94.0384 16.9384 90.5242 16.9171C87.0312 16.8532 85.2847 14.9576 85.2847 11.2091C85.2847 7.37534 86.7756 5.41586 89.7787 5.30937C91.1844 5.30937 92.2706 5.88443 92.9948 7.05586V2.26367H94.4005Z"
        fill="#113541"
      />
      <path
        d="M109.036 8.84494C109.036 9.67558 108.312 10.3358 107.481 10.3358H103.72V16.7467H100.802V3.81847C100.802 2.98782 101.462 2.26367 102.293 2.26367H110.932V4.77691H103.72V7.8865H109.036V8.84494Z"
        fill="#113541"
      />
      <path
        d="M115.698 5.30937C119.106 5.30937 120.831 7.24754 120.831 11.1665C120.831 15.0428 119.106 17.0023 115.698 17.0023C112.29 17.0023 110.586 15.0428 110.586 11.1665C110.586 7.24754 112.29 5.30937 115.698 5.30937ZM115.698 7.80131C114.207 7.80131 113.462 8.93013 113.462 11.1665C113.483 13.3602 114.228 14.4678 115.677 14.4678C117.125 14.4678 117.849 13.3176 117.87 11.0813C117.87 8.88754 117.146 7.80131 115.698 7.80131Z"
        fill="#113541"
      />
      <path
        d="M121.768 16.7467V10.9322C121.853 7.29014 123.792 5.47976 127.561 5.47976H127.966V8.41897H127.008C125.432 8.41897 124.644 9.24961 124.644 10.8896V16.7467H121.768Z"
        fill="#113541"
      />
      <path
        d="M138.797 13.2963C138.286 15.5966 136.625 17.0662 134.005 17.0023C130.597 17.0023 128.851 15.0428 128.766 11.1665C128.766 7.31144 130.491 5.37327 133.962 5.30937C136.689 5.30937 138.307 6.52339 138.797 8.97273H135.709C135.368 8.20598 134.772 7.80131 133.877 7.80131C132.386 7.80131 131.641 8.93013 131.641 11.1665C131.641 13.4028 132.429 14.5317 134.005 14.5104C134.665 14.5104 135.24 14.2335 135.709 13.701C135.986 13.4241 136.305 13.2963 136.667 13.2963H138.797Z"
        fill="#113541"
      />
      <path
        d="M149.811 13.2963C149.193 15.6818 147.66 17.0023 144.891 17.0023C141.483 16.8958 139.779 14.915 139.779 11.0813C139.779 7.24754 141.504 5.33067 144.934 5.30937C148.512 5.30937 150.194 7.50313 149.981 11.9119H142.697C142.804 13.6371 143.549 14.5104 144.934 14.5104C145.594 14.5104 146.211 14.2335 146.765 13.701C147.021 13.4241 147.34 13.2963 147.724 13.2963H149.811ZM144.891 7.63092C143.677 7.63092 142.953 8.39767 142.74 9.88857H146.978C146.808 8.39767 146.105 7.63092 144.891 7.63092Z"
        fill="#113541"
      />
      <path
        d="M55.0649 19.6477C55.0649 18.9714 55.6025 18.3818 56.2788 18.3818H58.6197L60.9954 27.3642L63.3016 18.3818H66.8911V30.1734H64.6195V20.6534L62.2092 30.1734H59.7468L57.3365 20.6534V30.1734H55.0649V19.6477Z"
        fill="#113541"
      />
      <path
        d="M71.3125 28.3001C72.5957 28.3001 73.376 27.5371 73.376 26.2366V25.3869C72.8384 25.6123 72.2142 25.8031 71.5379 25.9418C70.6189 26.1152 70.1507 26.5487 70.1507 27.225C70.2027 27.9533 70.5842 28.3001 71.3125 28.3001ZM71.85 22.5777C71.035 22.5777 70.5842 22.7858 70.4628 23.2193H68.1565C68.434 21.52 69.6305 20.6876 71.746 20.6876C74.2777 20.6876 75.5609 21.52 75.6129 23.2193V26.3406C75.6129 28.8723 74.0869 29.9995 71.6073 30.1729C69.405 30.3463 67.8791 29.3232 67.8791 27.2943C67.9311 25.0921 69.5264 24.5025 71.85 24.2771C72.8384 24.1557 73.3413 23.8609 73.3413 23.3581C73.2893 22.8378 72.8037 22.5777 71.85 22.5777Z"
        fill="#113541"
      />
      <path
        d="M84.544 30.1734H83.3648C82.6019 30.1213 82.2204 29.7572 82.2204 29.0289V24.3123C82.1684 23.3586 81.6482 22.8904 80.6251 22.8904C79.602 22.8904 79.0818 23.3586 79.0644 24.3123V30.1734H76.7235V24.7805C76.7235 22.1621 78.0414 20.8615 80.6598 20.8615C83.2781 20.8615 84.5613 22.1621 84.544 24.7805V30.1734Z"
        fill="#113541"
      />
      <path
        d="M88.8053 28.3001C90.0884 28.3001 90.8688 27.5371 90.8688 26.2366V25.3869C90.3312 25.6123 89.707 25.8031 89.0307 25.9418C88.1116 26.1152 87.6435 26.5487 87.6435 27.225C87.6955 27.9533 88.077 28.3001 88.8053 28.3001ZM89.3428 22.5777C88.5278 22.5777 88.077 22.7858 87.9556 23.2193H85.6493C85.9268 21.52 87.1232 20.6876 89.2388 20.6876C91.7705 20.6876 93.0536 21.52 93.1057 23.2193V26.3406C93.1057 28.8723 91.5797 29.9995 89.1 30.1729C86.8978 30.3463 85.3719 29.3232 85.3719 27.2943C85.4239 25.0921 87.0192 24.5025 89.3428 24.2771C90.3312 24.1557 90.8341 23.8609 90.8341 23.3581C90.7821 22.8378 90.2965 22.5777 89.3428 22.5777Z"
        fill="#113541"
      />
      <path
        d="M98.378 28.144C99.6265 28.144 100.285 27.2597 100.355 25.4909C100.372 23.6355 99.7305 22.7165 98.4126 22.7165C97.0948 22.7165 96.4532 23.6355 96.4532 25.4909C96.5052 27.2597 97.1295 28.144 98.378 28.144ZM97.7364 30.1729C95.2914 30.1729 94.0775 28.5775 94.0775 25.4216C94.0775 22.3696 95.4995 20.8437 98.3433 20.7917C101.204 20.7743 102.644 22.1269 102.644 24.884V30.3116C102.644 32.6179 101.187 33.7797 98.2566 33.8317C96.1757 33.8317 94.8579 32.8606 94.3203 30.9185H96.8694C97.0254 31.5774 97.563 31.8896 98.5167 31.8896C99.7305 31.8896 100.355 31.1786 100.355 29.7567C100.355 29.7567 100.355 29.774 100.355 28.8203C99.7652 29.722 98.8808 30.1729 97.7364 30.1729Z"
        fill="#113541"
      />
      <path
        d="M111.814 27.1903C111.311 29.1324 110.063 30.2075 107.809 30.2075C105.034 30.1208 103.647 28.5082 103.647 25.3869C103.647 22.2656 105.051 20.705 107.843 20.6876C110.756 20.6876 112.126 22.4737 111.953 26.0632H106.022C106.109 27.4677 106.716 28.1787 107.843 28.1787C108.381 28.1787 108.884 27.9533 109.335 27.5198C109.543 27.2943 109.803 27.1903 110.115 27.1903H111.814ZM107.809 22.5777C106.82 22.5777 106.231 23.202 106.057 24.4158H109.508C109.369 23.202 108.797 22.5777 107.809 22.5777Z"
        fill="#113541"
      />
      <path
        d="M116.931 22.8557C115.908 22.8557 115.388 23.3239 115.371 24.2776V30.1387H113.03V24.7458C113.03 22.1274 114.348 20.8268 116.966 20.8268C118.145 20.8268 119.047 21.087 119.706 21.6072C120.365 21.1043 121.267 20.8615 122.446 20.8615C125.064 20.8615 126.365 22.1621 126.347 24.7805V30.1734H125.151C124.388 30.1213 124.006 29.7572 124.006 29.0289V24.3123C123.954 23.3586 123.434 22.8904 122.411 22.8904C121.388 22.8904 120.868 23.3586 120.85 24.3123V30.1387H118.527V24.2776C118.475 23.3239 117.955 22.8557 116.931 22.8557Z"
        fill="#113541"
      />
      <path
        d="M135.776 27.1903C135.273 29.1324 134.024 30.2075 131.77 30.2075C128.996 30.1208 127.608 28.5082 127.608 25.3869C127.608 22.2656 129.013 20.705 131.805 20.6876C134.718 20.6876 136.088 22.4737 135.914 26.0632H129.984C130.071 27.4677 130.678 28.1787 131.805 28.1787C132.342 28.1787 132.845 27.9533 133.296 27.5198C133.504 27.2943 133.764 27.1903 134.076 27.1903H135.776ZM131.77 22.5777C130.782 22.5777 130.192 23.202 130.019 24.4158H133.469C133.331 23.202 132.759 22.5777 131.77 22.5777Z"
        fill="#113541"
      />
      <path
        d="M144.812 30.1734H143.633C142.87 30.1213 142.488 29.7572 142.488 29.0289V24.3123C142.436 23.3586 141.916 22.8904 140.893 22.8904C139.87 22.8904 139.35 23.3586 139.332 24.3123V30.1734H136.991V24.7805C136.991 22.1621 138.309 20.8615 140.928 20.8615C143.546 20.8615 144.829 22.1621 144.812 24.7805V30.1734Z"
        fill="#113541"
      />
      <path
        d="M149.541 21.5471C149.541 22.206 149.039 22.6916 148.397 22.6916H148.154V27.7723C148.154 28.1538 148.38 28.3619 148.83 28.3619H149.541V30.1133C148.796 30.1827 147.981 30.1827 147.114 30.096C146.247 30.0093 145.831 29.4717 145.848 28.4486V18.4258H147.044C147.651 18.4258 148.154 18.9807 148.154 19.5876V21.0442H149.541V21.5471Z"
        fill="#113541"
      />
      <g clip-path="url(#clip0_1248_13093)">
        <path
          d="M29.8675 0.0986328V0.106176L29.3772 0.962341C29.3734 0.969884 29.3697 0.973656 29.3697 0.977427L26.4693 6.0767L20.71 16.2073C20.661 16.2903 20.6119 16.3771 20.5629 16.4601L14.0418 27.9296C12.4992 30.6415 9.61765 32.3161 6.49474 32.3161H0L14.1361 7.46089L15.8258 4.48883C15.871 4.4134 15.9163 4.33042 15.9615 4.25499C15.9653 4.24745 15.9691 4.24368 15.9728 4.23613L15.9804 4.22482C16.003 4.1871 16.0294 4.14561 16.0558 4.1079C16.2633 3.79862 16.4896 3.50443 16.7347 3.2291C18.266 1.50546 20.3253 0.543687 22.5694 0.215554C22.7203 0.192924 22.8712 0.174066 23.022 0.158979C23.2785 0.132578 23.535 0.109948 23.7914 0.0986328H29.8675Z"
          fill="url(#paint0_linear_1248_13093)"
        />
        <path
          d="M33.8513 23.8185C34.5 22.6078 35.7559 21.8422 37.1288 21.8196L42.0621 21.7441L39.8783 25.8213C39.2296 27.032 37.9774 27.7976 36.6045 27.8165L31.6675 27.8919L33.8513 23.8185Z"
          fill="#347287"
        />
        <path
          d="M37.1663 12.8122L35.2164 16.2444L28.567 27.9365C27.0207 30.6521 24.1391 32.3267 21.02 32.3267H14.5215L22.6795 17.9869C22.6795 17.9869 22.6984 17.953 22.7059 17.9341L24.5993 14.6075C24.6672 14.4868 24.7388 14.3662 24.8143 14.2492C24.9538 14.0305 25.1047 13.8193 25.2593 13.6194C25.3197 13.5439 25.38 13.4685 25.4403 13.3931C27.1263 11.3715 29.6947 10.2324 32.3651 10.2324H32.3877C33.5494 10.2362 34.7072 10.2324 35.8689 10.2324C37.0758 10.372 37.7887 11.7185 37.1663 12.8122Z"
          fill="url(#paint1_linear_1248_13093)"
        />
        <path
          d="M46.0137 10.1836C45.3574 10.1836 44.5801 13.2085 44.3538 13.7327C43.788 15.0528 42.9771 16.3352 41.6872 17.048C39.8127 18.0852 37.4479 17.5949 35.6941 16.5464C35.5319 16.4483 35.3735 16.3502 35.2151 16.2446C34.2081 15.5884 33.269 14.8303 32.2204 14.2494C28.3696 12.1298 24.8809 14.8793 22.6782 17.9871C22.6858 17.9683 22.6971 17.9532 22.7046 17.9343L24.598 14.6077C24.6659 14.487 24.7375 14.3664 24.813 14.2494C24.9525 14.0307 25.1034 13.8195 25.258 13.6196C25.3184 13.5441 25.3787 13.4687 25.4391 13.3933C27.125 11.3717 29.6935 10.2326 32.3638 10.2326H32.3864C33.5481 10.2364 34.7059 10.2326 35.8676 10.2326L46.0137 10.1836Z"
          fill="#347287"
        />
        <path
          d="M39.2244 5.5138e-05C38.7492 5.5138e-05 37.9837 2.76468 37.8178 3.14184C36.758 5.6085 34.9702 7.36232 32.1604 7.5773C30.1727 7.72817 28.2077 7.08322 26.469 6.07619C26.1597 5.90269 25.8617 5.71411 25.5713 5.51798C24.2173 4.60524 22.8972 3.45866 21.2754 3.28516C18.5221 2.9872 15.7462 5.36712 14.1357 7.46038L15.8254 4.48832C15.8707 4.41289 15.916 4.32991 15.9612 4.25448C15.965 4.24694 15.9688 4.24316 15.9725 4.23562L15.9801 4.22431C16.0027 4.18659 16.0291 4.1451 16.0555 4.10738C16.2629 3.79811 16.4892 3.50392 16.7344 3.22859C18.2657 1.50495 20.325 0.543175 22.5691 0.215041C22.72 0.192412 22.8708 0.173553 23.0217 0.158467C23.2782 0.132065 23.5346 0.109435 23.7911 0.0981203C28.9168 -0.128179 34.0912 5.5138e-05 39.2244 5.5138e-05Z"
          fill="#347287"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1248_13093"
          x1="13.4401"
          y1="6.97447"
          x2="13.417"
          y2="25.3663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#194959" />
          <stop offset="1" stop-color="#347287" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1248_13093"
          x1="24.8147"
          y1="14.9478"
          x2="24.8006"
          y2="27.5607"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#194959" />
          <stop offset="1" stop-color="#347287" />
        </linearGradient>
        <clipPath id="clip0_1248_13093">
          <rect width="46.0139" height="32.4362" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AssignIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0407 3.96265L7.00335 8.99998L4.48535 6.48131"
        stroke="#10100F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 7C13 10.314 10.314 13 7 13C3.686 13 1 10.314 1 7C1 3.686 3.686 1 7 1C7.96867 1 8.88067 1.23533 9.69067 1.64267"
        stroke="#10100F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const StatusIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 5.5H2V3"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0001 8C14.0001 4.686 11.3141 2 8.00011 2C5.58011 2 3.49945 3.436 2.55078 5.5"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 10.5H14V13"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 8C2 11.314 4.686 14 8 14C10.42 14 12.5007 12.564 13.4493 10.5"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
